/**
 * This module, when loaded, bootstraps the angular application contained in './app'.
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import angular from 'angular';
import { applyPolyfills, defineCustomElements } from 'blip-ds/loader';

import app from './app';
import './assets/assets';

// imports prototype methods for the Function type
import 'data/function';
import 'data/array';
import 'data/object';
import blipLogo from './data/blip-logo.html';

// bootstrap angular application
angular.element(document).ready(() => {
    angular.bootstrap(document.documentElement, [app.name], {
        strictDi: false,
    });
});

// applying blip-ds
applyPolyfills().then(() => {
    defineCustomElements(window);
});

/* eslint-disable no-console */
console.log(`%c ${blipLogo}`, 'color: #00bcd4;');
/* eslint-enable no-console */
